import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { EllipsisOptionsPopoverComponent } from '../../../shared/components/popovers/ellipsis-options/ellipsis-options-popover.component';
import { DownloadRequestFileType } from '@usf/list-types';
import { DownloadListOptions } from '@usf/ngrx-list';
import { ListTypes } from '@shared/constants/lists-constants';

@Component({
  selector: 'app-download-list-v2',
  templateUrl: './download-list-v2.component.html',
  styleUrls: ['./download-list-v2.component.scss'],
})
export class DownloadListV2Component implements OnInit {
  @Input() listName: string;
  @Input() platformType: PlatformEnum;
  @Input() listTypeId: string;
  @Input() listId: number;
  @Input() isDownload = true;
  @Input() hidePricingOption: boolean;
  readonly platformEnum = PlatformEnum;

  fileName: string;
  format: DownloadRequestFileType;
  includeProductPrices = false;
  includeProductNotes = false;
  includeProductStatusAndType = false;
  includeMasterListAssociation = false;
  isRecentPurchase = false;

  fileTypeButtons = [
    {
      text: 'CSV',
      handler: () => {
        this.format = 'CSV';
        this.popoverController.dismiss();
      },
    },
    {
      text: 'XLSX',
      handler: () => {
        this.format = 'XLSX';
        this.popoverController.dismiss();
      },
    },
    {
      text: 'XML',
      handler: () => {
        this.format = 'XML';
        this.popoverController.dismiss();
      },
    },
    {
      text: 'PDF',
      handler: () => {
        this.format = 'PDF';
        this.popoverController.dismiss();
      },
    },
    {
      text: 'Price File',
      handler: () => {
        this.format = 'Price File';
        this.popoverController.dismiss();
      },
    },
    {
      text: 'Price File ASCII',
      handler: () => {
        this.format = 'Price File ASCII';
        this.popoverController.dismiss();
      },
    },
  ];

  @Output()
  downloadEmitter: EventEmitter<DownloadListOptions> = new EventEmitter();
  @Output() dismissEvent: EventEmitter<void> = new EventEmitter();

  constructor(private popoverController: PopoverController) {}

  ngOnInit(): void {
    this.fileName = this.listName;
    this.format = this.isDownload ? 'CSV' : 'PDF';
    if (this.listTypeId === ListTypes.recentlyPurchased) {
      this.isRecentPurchase = true;
      this.includeProductNotes = false;
    } else {
      this.isRecentPurchase = false;
    }
  }

  dismiss() {
    this.dismissEvent.emit();
  }

  download() {
    this.downloadEmitter.emit({
      fileName: this.fileName,
      format: this.format,
      includeProductNotes: this.includeProductNotes,
      includeProductPrices: this.includeProductPrices,
      includeProductType: this.includeProductStatusAndType,
      includeProductStatus: this.includeProductStatusAndType,
      includeMasterListAssociation: this.includeMasterListAssociation,
      includeNutritionals: false,
      listId: this.listId,
      listTypeId: this.listTypeId,
      listName: this.listName,
      isDownload: this.isDownload,
    });
  }

  async openFiletypePopover(event) {
    const listOptionsPopover = await this.popoverController.create({
      component: EllipsisOptionsPopoverComponent,
      event,
      componentProps: {
        buttons: this.fileTypeButtons,
      },
      cssClass: 'download-list-options-popover-desktop',
      mode: 'ios',
      showBackdrop: false,
    });
    await listOptionsPopover.present();
  }

  closeFiletypePopover() {
    this.popoverController.dismiss();
  }
}
